"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKEN_PATH = exports.USER_INFO_PATH = exports.SENDER_EDITOR_PATH = exports.PERSONAL_SENDER_EDITOR_PATH = exports.INVITATION_EXPIRED_PURL_PATH = exports.INVITATION_CONSUMED_PURL_PATH = exports.INDEX_SECURITY_PATH = exports.INDEX_PURL_PATH = exports.ERROR_PATH = exports.PENDING_PATH = exports.SERVER_ERROR_PATH = exports.NOT_FOUND_PATH = void 0;
exports.NOT_FOUND_PATH = 'errors/404';
exports.SERVER_ERROR_PATH = 'errors/500';
exports.PENDING_PATH = 'errors/pending';
exports.ERROR_PATH = '/error';
exports.INDEX_PURL_PATH = 'index-purl';
exports.INDEX_SECURITY_PATH = 'index-security';
exports.INVITATION_CONSUMED_PURL_PATH = 'invitation-consumed-purl';
exports.INVITATION_EXPIRED_PURL_PATH = 'invitation-expired-purl';
exports.PERSONAL_SENDER_EDITOR_PATH = '/personal-sender-edito';
exports.SENDER_EDITOR_PATH = '/sender-edito';
exports.USER_INFO_PATH = '/protocol/openid-connect/userinfo';
exports.TOKEN_PATH = '/v3/token';
